/**
 * Created by ganlu on 30/10/2016.
 */
import template from './progressbar.html';
import './progressbar.scss';

let progressbarComponent = {
    restrict: 'E',
    bindings: {
        text: '=',
        progress: '='
    },
    template
};

export default progressbarComponent;



// WEBPACK FOOTER //
// ./src/app/common/progressbar/progressbar.component.js